<template>
  <div class="glide relative">
    <div class="glide__track overflow-hidden rounded-xl" data-glide-el="track">
      <ul class="glide__slides flex flex-start items-center" ref="slides" data-glide-el="controls"
       :style="categoryCarouselTotalHeight"
      >
        <slot />
      </ul>
    </div>
    <div data-glide-el="controls"
     v-if="!controlsHidden"
    >
      <button
        data-glide-dir="<"
        class="rounded-full absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2"
        :class="[hasKiosk?'p-2':'bg-red-200 p-1 2xl:p-2']"
        :style="kioskDetailBackground"
      >
        <Icon name="chevron-left" size="1.6rem" :color="hasKiosk?kioskNavIconColor:'#e51e1e'" />
      </button>
      <button
        data-glide-dir=">"
        class="rounded-full absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-1/2"
        :class="[hasKiosk?'p-2':'bg-red-200 p-1 2xl:p-2']"
        :style="kioskDetailBackground"
      >
        <Icon name="chevron-right" size="1.6rem" :color="hasKiosk?kioskNavIconColor:'#e51e1e'" />
      </button>
    </div>
  </div>
</template>

<script>
import Glide from "@glidejs/glide";
import { mapGetters } from "vuex";
import Icon from "../components/Icon";

export default {
  computed: {
    ...mapGetters("Theme", ["kioskNavIconColor", "kioskDetailBackground", "categoryCarouselTotalHeight",]),
    ...mapGetters(["hasKiosk"]),
  },
  data() {
    return {
      glide: undefined,
    };
  },
  props: {
    options: Object,
    controlsHidden: Boolean,
  },
  components: {
    Icon,
  },
  mounted() {
    this.glide = new Glide(".glide", {
      type: "slide",
      perView: 3,
      focusAt: "center",
      perTouch: 3,
      ...this.options,
    }).mount();

    this.glide.on("mount.after", () => {
      this.$emit("mounted", this.glide);
    });
  },
  updated() {
    // if(!this.hasKiosk){
      // update the glide
      this.glide.update();
    // }
  },

  watch: {
    "glide.index": function(v) {
      this.$emit("change", v);
    },
  },
  beforeDestroy() {
    this.glide.destroy();
  },
};
</script>

<style></style>
